(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();
  const url = new URL(window.location.href);
   const params = new URLSearchParams(url.search);

  //if (params.has('target') && params.get('target') === 'TR') {
  // Generate an array of valid targets from JOY1 to JOY20
   const validTargets = Array.from({ length: 20 }, (_, i) => `JOY${i + 1}`);

 // Add JOY2025 explicitly to the array
 // validTargets.push('JOY2025');
  validTargets.push('TR');

 // Check if the target parameter matches any value in the array
  if (params.has('target') && validTargets.includes(params.get('target'))) {
    const target = params.get('target'); // Fetch the target parameter
    localStorage.setItem('tcode', 'TR30');

    switch (target) {
        case 'TR':
            document.getElementById('joyH3').innerHTML = "Get 30% off <br> Use our code";
            break;
        default:
            console.error('Invalid target parameter');
            return; // Exit the function if invalid
    }
    // Update content and show popup
    if(target=='TR'){
          document.getElementById('contentToCopy').innerText = 'TR30';
    } else {
          document.getElementById('contentToCopy').innerText = target;
    }

    $(".popup-section").fadeIn();
    $(".popup-section").css("display", "flex");
} else if(params.has('gclid') || params.has('fbclid')) {
      localStorage.setItem('tcode', 'TR30');
     document.getElementById('joyH3').innerHTML = "Get 30% off <br> Use our code";
    document.getElementById('contentToCopy').innerText = 'TR30';
     $(".popup-section").fadeIn();
    $(".popup-section").css("display", "flex");
  
} else if(params.has('d') && params.get('d').startsWith('Ad-')) {
      localStorage.setItem('tcode', 'TR30');
    document.getElementById('joyH3').innerHTML = "Get 30% off <br> Use our code";
    document.getElementById('contentToCopy').innerText = 'TR30';
     $(".popup-section").fadeIn();
    $(".popup-section").css("display", "flex");
  
}

  function closePopupWithDelay() {
    $(".popup-section").fadeOut();
    $('#statusMessage').text('');
}
   $(".close-icon").click(function () {
                $(".popup-section").fadeOut();
                $('#statusMessage').text('');
            });

            $('#copyButton').click(function () {
                const tempTextArea = $('<textarea>');
                $('body').append(tempTextArea);
                tempTextArea.val($('#contentToCopy').text()).select();
                document.execCommand('copy');
                tempTextArea.remove();
                $('#statusMessage').text('Code copied!');
              setTimeout(closePopupWithDelay, 500);
            });


})();